import React from "react";
import "../css/AnswerButton.css";
import { AnswerButtonType } from "../types/AnswerButtonType";

interface AnswerButtonProps {
  answer: string;
  isSelected: boolean;
  onClick: () => void;
  type?: AnswerButtonType;
  isDisabled?: boolean;
}

// Function to convert AnswerButtonType to CSS class name
const getTypeClass = (type: AnswerButtonType): string => {
  switch (type) {
    case AnswerButtonType.CORRECT:
      return 'correct';
    case AnswerButtonType.INCORRECT:
      return 'incorrect';
    case AnswerButtonType.SELECTED:
      return 'selected';
    default:
      return 'default';
  }
};

const AnswerButton: React.FC<AnswerButtonProps> = ({
  answer,
  isSelected,
  onClick,
  type = AnswerButtonType.DEFAULT,
  isDisabled = false
}) => {
  return (
    <button
      className={`answer-button ${isSelected ? 'selected' : ''} ${getTypeClass(type)} ${isDisabled ? 'disabled' : ''}`}
      onClick={isDisabled ? undefined : onClick}
    >
      {answer}
    </button>
  );
};

export default AnswerButton;
